import { ProductDetailPage } from 'product-detail/product-detail-page';
import { ProductsPage } from 'products/products-page';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ROUTES } from './routes';

export function ProductRoutes() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={path} exact>
                <ProductsPage />
            </Route>
            <Route path={`${path}/:id`}>
                <ProductDetailPage />
            </Route>
            <Route path='*'>
                <Redirect to={ROUTES.products} />
            </Route>
        </Switch>
    );
}
